<h3 mat-dialog-title>{{title}}</h3>
<div class="mat-dialog-content" class="width-sm">
    <div [innerHTML]="message"></div>

    <br *ngIf="message">
    <mat-input-container class="width-full">
        <input matInput type="text" [placeholder]="placeholder" [(ngModel)]="input" (keyup.enter)="onKey()">
    </mat-input-container>
</div>
<div mat-dialog-actions class="pull-right">
    <button mat-button (click)="onCancel()">{{cancelText}}</button>
    <button mat-raised-button [color]="confirmColor" (click)="onConfirm()">{{confirmText}}</button>
</div>
